import React from "react";
import {ArrowBackCircle} from 'react-ionicons'
import 'bootstrap/dist/css/bootstrap.min.css';
import 'jquery/dist/jquery.min.js';
import 'bootstrap/dist/js/bootstrap.min.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import "@popperjs/core"
import constantURI from "../URI"
import _post from "../Functions/NoBodyPost";
import WMSAuthenticate from "../Functions/WMSAuthenticate"
import stylesWMS from "./stylesWMS";
import stylesMed from "../MedRep/stylesMed";
import {db, doc, setDoc} from '../firebase';

export default class TransactionDetail extends React.Component {

    constructor() {
        super();
        this.state = {
            orderLines: [],
            orderLinesCopy: [],
            bar: "",
            authenticate: false,
            token: "",
            order: "",
            stages: [],
            task: [],
            status: "",
            disableSave: false,
            loading: true,
            tableHeader: [{"name": "Category"}, {"name": "Destination"}, {"name": "Ordered Qty"}],
            transactionType: [{"name": "/RequestDetail"}, {"name": "/TransferDetail"}],
            selectedType: -1,
            result: [],
            transaction: -1,
            categories: [],
            allCategoryProducts: [],
            username: ""
        }
    }

    async componentDidMount() {
        document.body.style.backgroundColor = "#e6e6fa";

        //Setting the transaction type
        await this.state.transactionType.map((item, index) => {
            if (this.props.history.location.pathname === item.name) {
                this.setState({selectedType: index});
            }
        })
        //checking if there is internet connectivity 
        await WMSAuthenticate().then((response) => {
            this.setState({authenticate: response});
        });
        const token = JSON.parse(localStorage.getItem("Token"));
        const user = JSON.parse(localStorage.getItem("Username"));
        const order = JSON.parse(localStorage.getItem("Transaction"));
        this.setState({token: token, order: order, username: user});
        //Setting the transaction based on selected module
        const title = JSON.parse(localStorage.getItem("Title"));
        if (title[0] === 4) {
            this.setState({transaction: 0}); //WMS
        } else if (title[0] === 5) {
            this.setState({transaction: 1}); //OMS
        }

        if (this.state.transaction === 0) {
            this.compWMS();
        } else {
            this.compOMS();
        }
    }

    compOMS = async () => {
        var getSOLines = constantURI() + "GetSOLines?token=" + this.state.token + "&user=" + this.state.username + "&SOId=" + this.state.order.id;
        //If online
        if (this.state.authenticate) {
            await _post(getSOLines).then((response) => {
                return response.json().then((data) => {
                    if (data.result !== undefined) {
                        this.setState({orderLines: data.result});
                        localStorage.setItem("TransactionLines", JSON.stringify(data.result));
                    } else
                        alert("Please try again");
                })
            })
            this.setState({orderLinesCopy: this.state.orderLines, loading: false});
        }
        //If offline
        else {
            const transfers = JSON.parse(localStorage.getItem('TransactionLines'));
            if (transfers === null || transfers === undefined) {
                alert("Please connect to the Internet");
                this.props.history.goBack();
            } else {
                this.setState({orderLines: transfers, orderLinesCopy: transfers, loading: false});
            }
        }
    }

    compWMS = async () => {
        var readURI = constantURI();
        var movesURI = constantURI();
        //If transaction is RFQ
        if (this.state.selectedType === 0) {
            readURI = readURI + "GetPOLines?token=" + this.state.token + "&user=" + this.state.username + "&POId=" + this.state.order.id;
        }
        //If transaction is transfer
        else {
            readURI = readURI + "GetTransferLines?token=" + this.state.token + "&user=" + this.state.username + "&transferId=" + this.state.order.id;
            movesURI = movesURI + "GetTransferMoves?token=" + this.state.token + "&user=" + this.state.username + "&transferId=" + this.state.order.id;
        }
        //If online
        if (this.state.authenticate) {
            await _post(readURI).then((response) => {
                return response.json().then((data) => {
                    if (data.result !== undefined)
                        this.setState({orderLines: data.result});
                    else
                        alert("Please try again");
                })
            })
            if (this.state.selectedType === 0) {
                await this.setState({orderLinesCopy: this.state.orderLines});
                await this.getProductCategory();
            } else {
                var temp = this.state.orderLines;
                await _post(movesURI).then((response) => {
                    return response.json().then(async (data) => {
                        if (data.result !== undefined) {
                            await this.setState({result: data.result});
                            await this.state.result.map((item, index) => {
                                temp.map((item2, index2) => {
                                    if (item.product_id[0] === item2.product_id[0]) {
                                        temp[index2].status = item.track_status;
                                        temp[index2].MarkId = item.id;
                                    }
                                })
                            })
                            await this.setState({orderLines: temp, orderLinesCopy: temp});
                        } else {
                            alert("Please try again");
                        }
                    })
                })
            }
        }
        //If offline
        else {
            const transfers = JSON.parse(localStorage.getItem('TransactionLines'));
            if (transfers === null || transfers === undefined) {
                alert("Please connect to the Internet");
                this.props.history.goBack();
            } else {
                await this.setState({orderLines: transfers, orderLinesCopy: transfers});
                if (this.state.selectedType === 0) {
                    await this.getProductCategory();
                }
            }
        }
        //If user is driver or destination warehouse manager
        if (this.state.selectedType === 1) {
            var temp = [];
            const groups = await this.groupArrayOfObjects(this.state.orderLines, "result_package_id");
            Object.entries(groups).map(([key, value], index) => {
                temp[index] = {}
                temp[index].name = key;
                temp[index].isFound = false;
            })
            this.setState({orderLines: temp, loading: false});
        }
    }

    getProductCategory = async () => {
        //Get the categories for each order line
        var temp = [];
        var tempArr = [];
        var counter = 0;
        await Promise.all(
            await this.state.orderLines.map(async (item, index, arr) => {
                const categoryURL = constantURI() + "GetCategory?token=" + this.state.token + "&user=" + this.state.username + "&id=" + item.product_id[0] + "&type=" + "consu";
                if (this.state.authenticate) {
                    await _post(categoryURL).then(async (response) => {
                        return response.json().then(async (data) => {
                            if (data.result !== undefined && data.result.length !== 0) {
                                var tempObj = {};
                                tempObj.id = item.product_id[0];
                                const misc1 = (data.result[0].misc1[0] !== undefined) ? data.result[0].misc1[0] : false;
                                const misc3 = (data.result[0].misc3[0] !== undefined) ? data.result[0].misc3[0] : false;
                                const misc5 = (data.result[0].misc5[0] !== undefined) ? data.result[0].misc5[0] : false;
                                const misc6 = (data.result[0].misc6[0] !== undefined) ? data.result[0].misc6[0] : false;
                                const getProductCategoryURL = constantURI() + "GetProductsByCategories?token=" + this.state.token + "&user=" + this.state.username + "&misc1=" + misc1 + "&misc3=" +
                                    misc3 + "&misc5=" + misc5 + "&misc6=" + misc6;
                                await _post(getProductCategoryURL).then((response) => {
                                    return response.json().then(async (data) => {
                                        if (data.result !== undefined) {
                                            tempObj.products = data.result;
                                            await tempArr.push(tempObj);
                                            await counter++;
                                            if (counter === arr.length) {
                                                await this.setState({allCategoryProducts: tempArr});
                                                await localStorage.setItem("AllCategoryProducts", JSON.stringify(this.state.allCategoryProducts));
                                                console.log(this.state.allCategoryProducts);
                                                this.state.allCategoryProducts.forEach(async (docu) => {
                                                    await setDoc(doc(db, "AllCategoryProducts", docu.id.toString()), {
                                                        products: docu.products
                                                    }).then(() => {
                                                        console.log('Data added successfully!');
                                                    })
                                                        .catch((error) => {
                                                            console.error('Error adding data:', error);
                                                        });
                                                });
                                            }
                                            await temp.push(data.result[0]);
                                            if (counter === arr.length) {
                                                await this.setState({
                                                    categories: temp,
                                                    source: this.state.order.source_location_id[0],
                                                    loading: false
                                                });
                                                await localStorage.setItem("ProductCategories", JSON.stringify(this.state.categories));
                                            }
                                        } else {
                                            alert("Please try again");
                                        }
                                    })
                                });
                            } else
                                alert("Please try again");
                        })
                    })
                } else {
                    alert("Please connect to the internet");
                }
            })
        )
    }

    //fetchAllCategoryProducts = async () => {
    //    var tempArr = [];
    //    await this.state.categories.map(async (item, index, arr) => {
    //        var tempObj = {};
    //        tempObj.id = item.id;
    //        const misc1 = (item.misc1[0] !== undefined) ? item.misc1[0] : false;
    //        const misc3 = (item.misc3[0] !== undefined) ? item.misc3[0] : false;
    //        const misc5 = (item.misc5[0] !== undefined) ? item.misc5[0] : false;
    //        const misc6 = (item.misc6[0] !== undefined) ? item.misc6[0] : false;
    //        const getProductCategoryURL = constantURI() + "GetProductsByCategories?token=" + this.state.token + "&user=" + this.state.username+ "&misc1=" + misc1 + "&misc3=" +
    //            misc3 + "&misc5=" + misc5 + "&misc6=" + misc6;
    //        await _post(getProductCategoryURL).then((response) => {
    //            return response.json().then(async (data) => {
    //                if (data.result !== undefined) {
    //                    tempObj.products = data.result;
    //                    tempArr.push(tempObj);
    //                }
    //                else {
    //                    alert("Please try again");
    //                }
    //            })
    //        });
    //        if (index === arr.length - 1) {
    //            this.setState({ allCategoryProducts: tempArr, loading: false });
    //            localStorage.setItem("AllCategoryProducts", JSON.stringify(this.state.allCategoryProducts));
    //        }
    //    })
    //}

    onStart = async () => {
        //checking if there is internet connectivity 
        await WMSAuthenticate().then((response) => {
            this.setState({authenticate: response});
        });
        //If online
        if (this.state.authenticate) {
            localStorage.setItem("TransactionLines", JSON.stringify(this.state.orderLinesCopy));
            this.props.history.push(this.state.transactionType[this.state.selectedType].name.substring(0, this.state.transactionType[this.state.selectedType].name.indexOf("Detail")));
        }
        //If offline
        else {
            alert("Please connect to the internet");
        }
    }

    groupArrayOfObjects(list, key) {
        return list.reduce(function (rv, x) {
            (rv[x[key]] = rv[x[key]] || []).push(x);
            return rv;
        }, {});
    }

    render() {
        if (!this.state.loading) {
            return (
                <div className="container-fluid vh-100" style={stylesWMS.mainContainer}>
                    <div className="row pt-3">
                        <div className="col">
                            <ArrowBackCircle className="btn"
                                             onClick={() => this.props.history.push(this.state.transactionType[this.state.selectedType].name.substring(0, this.state.transactionType[this.state.selectedType].name.indexOf("Detail")) + "s")}
                                             color={'#00bfff'} height="50px" width="50px"/>
                        </div>
                        <div className="total col d-flex align-items-center"><b>{this.state.order.name}</b></div>
                        <div className="col d-flex flex-row-reverse">
                            <div className={(this.state.disableSave) ? "getorder btn disabled" : "getorder btn"}
                                 onClick={() => this.onStart()}>{(this.state.selectedType === 0) ? "Start Packing" : "Scan Packages"}</div>
                        </div>
                    </div>
                    <h3 className="little m-4">Order Details</h3>
                    <div className="m-4 p-3" style={stylesMed.cardBackgroundColor}>
                        <div className="row">
                            <p className="little col-3">Type: <b>{(this.state.order.type_id !== undefined) ? this.state.order.type_id[1] : this.state.order.picking_type_id[1]}</b>
                            </p>
                            <p className="little col-4">Order
                                Date: <b>{(this.state.order.date_order !== undefined) ? this.state.order.date_order.substring(0, 10) : this.state.order.scheduled_date.substring(0, 10)}</b>
                            </p>
                            <p className="little col-5">{(this.state.order.partner_id !== undefined) ? "Customer: " : "Stage: "}<b>{(this.state.order.partner_id !== undefined) ? this.state.order.partner_id[1] : this.state.order.stage_id[1]}</b>
                            </p>
                        </div>
                        {(this.state.transaction === 0) ?
                            <div className="row">
                                <p className="little col">Source: <b>{(this.state.order.location_id !== undefined) ? this.state.order.location_id[1] : this.state.order.source_location_id[1]}</b>
                                </p>
                                <p className="little col">Destination: <b>{(this.state.order.location_dest_id !== undefined) ? this.state.order.location_dest_id[1] : this.state.order.dest_location_id[1]}</b>
                                </p>
                                <p className="little col invisible"></p>
                            </div>
                            :
                            null
                        }
                    </div>
                    {(this.state.transaction === 1 && this.state.selectedType === 1) ? null :
                        <div>
                            <h3 className="little m-4">Order Lines</h3>
                            <div className="m-4 mt-0 p-3" style={stylesMed.cardBackgroundColor}>
                                {(this.state.selectedType === 0 && this.state.transaction != 1) ?
                                    <div className="row">
                                        {this.state.tableHeader.map((item, index) => {
                                            return (
                                                <div className="little col-4 text-center" key={index}>
                                                    <b> {item.name}</b></div>
                                            )
                                        })
                                        }
                                    </div>
                                    : null
                                }
                                <hr/>
                                {this.state.orderLines.map((item, index) => {
                                    return (
                                        <div key={index}>
                                            {(this.state.selectedType === 0 && this.state.transaction != 1) ?
                                                <div className="row" key={index}>
                                                    <div
                                                        className="little col-4 text-center"> {(item.product_id === undefined) ? item.name.substring(item.name.indexOf("FTR"), item.name.length) : item.product_id[1]} </div>
                                                    <div
                                                        className="little col-4 text-center"> {item.location_dest_id[1]} </div>
                                                    <div
                                                        className="little col-4 text-center"> {item.product_uom_qty} </div>
                                                </div> :
                                                <div className="row" key={index}>
                                                    <h4 className="col text-center"> {(item.product_id === undefined) ? item.name.substring(item.name.indexOf("FTR"), item.name.length) : item.product_id[1]} </h4>
                                                </div>
                                            }

                                            <hr/>
                                        </div>
                                    )
                                })
                                }
                            </div>
                        </div>
                    }
                </div>
            );
        } else {
            return (
                <div className="container-fluid vh-100" style={stylesMed.mainContainer}>
                    <div className="pt-3 text-center">
                        <div className="spinner-border" style={stylesMed.spinner}></div>
                    </div>
                </div>
            )
        }
    }
}
